// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rightsholder-maintenance-banking-tab {
  padding: 0 4.8rem 0 0;
  height: auto;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderScene/RightsholderMaintenance/RightsholderMaintenanceBankingTab/index.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,YAAA;AACF","sourcesContent":[".rightsholder-maintenance-banking-tab {\n  padding: 0 4.8rem 0 0;\n  height: auto;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
